import { NavLink } from "react-router-dom";
import { ResponsivePresetKeys, ResponsivePresets } from "../../../modules/configs/responsiveImageConfigs";
import { Artist, ElasticArtist } from "../../../modules/graphql/api.generated";
import { FocusableComponentLayout, useFocusable } from "../../../modules/spatialNavigation";
import ImageGenerator from "../imageGenerator/ImageGenerator";
import { IDisplayedCast } from "./artist.interface";
import * as styles from "./styles.module.scss";

interface IProps {
  data: IDisplayedCast;
  focusKey?: string;
  index?: number;
  onClick?: () => void;
  onMovieFocus?: () => void;
  onKeydown?: (e: any) => void;
  onEnterPress: (program: Artist) => void;
  onFocus: (layout: FocusableComponentLayout, entity: IDisplayedCast) => void;
}

const ArtistCard = (props: IProps) => {
  const { ref, focused } = useFocusable({
    focusKey: props.focusKey,
    onEnterPress: props.onEnterPress,
    onFocus: (l: FocusableComponentLayout) => {
      return props.onFocus(l, props.data);
    },
  });

  return (
    <NavLink
      ref={ref}
      className={`${styles.artistCard} ${focused ? styles.focused : ""}`}
      to={`/a/${props.data.artist.descriptor}`}
    >
      <div className={styles.artistImage}>
        <ImageGenerator
          lazyLoad
          noBlurPlaceholder={true}
          imageType="square"
          sizes={ResponsivePresets[ResponsivePresetKeys.ARTIST_SEARCH_RESULT]}
          src={props.data.artist.imagePath}
        />
      </div>
      <h6 className={styles.artistName}>{props.data.artist.fullName}</h6>
      <p className={styles.artistRole}>{props.data.roles.join(", ")}</p>
    </NavLink>
  );
};
export default ArtistCard;
